import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../Graphic.js";
import a from "../../core/Collection.js";
import i from "../../core/Error.js";
import { HandleOwner as n } from "../../core/HandleOwner.js";
import { isSome as r } from "../../core/maybe.js";
import { init as s } from "../../core/watchUtils.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { cast as c } from "../../core/accessorSupport/decorators/cast.js";
import { subclass as h } from "../../core/accessorSupport/decorators/subclass.js";
import d from "../../rest/query/support/AttachmentInfo.js";
import m from "../../rest/support/AttachmentQuery.js";
import { getSourceLayer as l } from "../Feature/support/featureUtils.js";
var p = {
  editing: !1,
  operations: {
    add: !0,
    update: !0,
    delete: !0
  }
},
    u = a.ofType(d),
    y = "graphic.layer.capabilities.operations.supportsResizeAttachments";

var f = /*#__PURE__*/function (_n) {
  _inherits(f, _n);

  var _super = _createSuper(f);

  function f(t) {
    var _this;

    _classCallCheck(this, f);

    _this = _super.call(this, t), _this._getAttachmentsPromise = null, _this._attachmentLayer = null, _this.abilities = _objectSpread({}, p), _this.activeAttachmentInfo = null, _this.attachmentInfos = new u(), _this.graphic = null, _this.mode = "view", _this.handles.add([s(_assertThisInitialized(_this), "graphic", function () {
      return _this._graphicChanged();
    })]);
    return _this;
  }

  _createClass(f, [{
    key: "destroy",
    value: function destroy() {
      this._attachmentLayer = null, this.graphic = null;
    }
  }, {
    key: "castAbilities",
    value: function castAbilities(t) {
      return _objectSpread(_objectSpread({}, p), t);
    }
  }, {
    key: "state",
    get: function get() {
      return this._getAttachmentsPromise ? "loading" : this.graphic ? "ready" : "disabled";
    }
  }, {
    key: "supportsResizeAttachments",
    get: function get() {
      return this.get(y) || !1;
    }
  }, {
    key: "getAttachments",
    value: function () {
      var _getAttachments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var t, e, a, n, r, s, o;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this._attachmentLayer, e = this.attachmentInfos;

                if (!(!t || "function" != typeof t.queryAttachments)) {
                  _context.next = 3;
                  break;
                }

                throw new i("invalid-layer", "getAttachments(): A valid layer is required.");

              case 3:
                a = this._getFeatureId(), n = new m({
                  objectIds: [a],
                  returnMetadata: !0
                }), r = [], s = t.queryAttachments(n).then(function (t) {
                  return t[a] || r;
                }).catch(function () {
                  return r;
                });
                this._getAttachmentsPromise = s, this.notifyChange("state");
                _context.next = 7;
                return s;

              case 7:
                o = _context.sent;
                return _context.abrupt("return", (e.removeAll(), o.length && e.addMany(o), this._getAttachmentsPromise = null, this.notifyChange("state"), o));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAttachments() {
        return _getAttachments.apply(this, arguments);
      }

      return getAttachments;
    }()
  }, {
    key: "addAttachment",
    value: function () {
      var _addAttachment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        var _this2 = this;

        var e, a, n, r, s, o;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e = this._attachmentLayer, a = this.attachmentInfos, n = this.graphic, r = this.abilities;

                if (t) {
                  _context2.next = 3;
                  break;
                }

                throw new i("invalid-attachment", "addAttachment(): An attachment is required.", {
                  attachment: t
                });

              case 3:
                if (r.operations.add) {
                  _context2.next = 5;
                  break;
                }

                throw new i("invalid-abilities", "addAttachment(): add abilities are required.");

              case 5:
                if (!(!e || "function" != typeof e.addAttachment)) {
                  _context2.next = 7;
                  break;
                }

                throw new i("invalid-layer", "addAttachment(): A valid layer is required.");

              case 7:
                s = e.addAttachment(n, t).then(function (t) {
                  return _this2._queryAttachment(t.objectId);
                });
                _context2.next = 10;
                return s;

              case 10:
                o = _context2.sent;
                return _context2.abrupt("return", (a.add(o), o));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addAttachment(_x) {
        return _addAttachment.apply(this, arguments);
      }

      return addAttachment;
    }()
  }, {
    key: "deleteAttachment",
    value: function () {
      var _deleteAttachment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
        var e, a, n, r, s, o;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e = this._attachmentLayer, a = this.attachmentInfos, n = this.graphic, r = this.abilities;

                if (t) {
                  _context3.next = 3;
                  break;
                }

                throw new i("invalid-attachment-info", "deleteAttachment(): An attachmentInfo is required.", {
                  attachmentInfo: t
                });

              case 3:
                if (r.operations.delete) {
                  _context3.next = 5;
                  break;
                }

                throw new i("invalid-abilities", "deleteAttachment(): delete abilities are required.");

              case 5:
                if (!(!e || "function" != typeof e.deleteAttachments)) {
                  _context3.next = 7;
                  break;
                }

                throw new i("invalid-layer", "deleteAttachment(): A valid layer is required.");

              case 7:
                s = e.deleteAttachments(n, [t.id]).then(function () {
                  return t;
                });
                _context3.next = 10;
                return s;

              case 10:
                o = _context3.sent;
                return _context3.abrupt("return", (a.remove(o), o));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteAttachment(_x2) {
        return _deleteAttachment.apply(this, arguments);
      }

      return deleteAttachment;
    }()
  }, {
    key: "updateAttachment",
    value: function () {
      var _updateAttachment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
        var _this3 = this;

        var e,
            a,
            n,
            r,
            s,
            o,
            c,
            h,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : this.activeAttachmentInfo;
                a = this._attachmentLayer, n = this.attachmentInfos, r = this.graphic, s = this.abilities;

                if (t) {
                  _context4.next = 4;
                  break;
                }

                throw new i("invalid-attachment", "updateAttachment(): An attachment is required.", {
                  attachment: t
                });

              case 4:
                if (e) {
                  _context4.next = 6;
                  break;
                }

                throw new i("invalid-attachment-info", "updateAttachment(): An attachmentInfo is required.", {
                  attachmentInfo: e
                });

              case 6:
                if (s.operations.update) {
                  _context4.next = 8;
                  break;
                }

                throw new i("invalid-abilities", "updateAttachment(): Update abilities are required.");

              case 8:
                o = n.findIndex(function (t) {
                  return t === e;
                });

                if (!(!a || "function" != typeof a.updateAttachment)) {
                  _context4.next = 11;
                  break;
                }

                throw new i("invalid-layer", "updateAttachment(): A valid layer is required.");

              case 11:
                c = a.updateAttachment(r, e.id, t).then(function (t) {
                  return _this3._queryAttachment(t.objectId);
                });
                _context4.next = 14;
                return c;

              case 14:
                h = _context4.sent;
                return _context4.abrupt("return", (n.splice(o, 1, h), h));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateAttachment(_x3) {
        return _updateAttachment.apply(this, arguments);
      }

      return updateAttachment;
    }()
  }, {
    key: "_queryAttachment",
    value: function () {
      var _queryAttachment2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t) {
        var e, a, n;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (t) {
                  _context5.next = 2;
                  break;
                }

                throw new i("invalid-attachment-id", "Could not query attachment.");

              case 2:
                e = this._attachmentLayer, a = this._getFeatureId(), n = new m({
                  objectIds: [a],
                  attachmentsWhere: "AttachmentId=".concat(t),
                  returnMetadata: !0
                });
                return _context5.abrupt("return", e.queryAttachments(n).then(function (t) {
                  return t[a][0];
                }));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _queryAttachment(_x4) {
        return _queryAttachment2.apply(this, arguments);
      }

      return _queryAttachment;
    }()
  }, {
    key: "_getFeatureId",
    value: function _getFeatureId() {
      var t = this._attachmentLayer,
          e = this.graphic;
      if (!t || !e) return null;
      var a = t.objectIdField,
          i = e.attributes;
      return i && i[a];
    }
  }, {
    key: "_graphicChanged",
    value: function _graphicChanged() {
      this.graphic && (this._setAttachmentLayer(), this.getAttachments().catch(function () {}));
    }
  }, {
    key: "_setAttachmentLayer",
    value: function _setAttachmentLayer() {
      var t = this.graphic,
          e = l(t);
      this._attachmentLayer = e ? "scene" === e.type && r(e.associatedLayer) ? e.associatedLayer : e : null;
    }
  }]);

  return f;
}(n);

t([o()], f.prototype, "abilities", void 0), t([c("abilities")], f.prototype, "castAbilities", null), t([o()], f.prototype, "activeAttachmentInfo", void 0), t([o({
  readOnly: !0,
  type: u
})], f.prototype, "attachmentInfos", void 0), t([o({
  type: e
})], f.prototype, "graphic", void 0), t([o()], f.prototype, "mode", void 0), t([o({
  readOnly: !0
})], f.prototype, "state", null), t([o({
  readOnly: !0
})], f.prototype, "supportsResizeAttachments", null), f = t([h("esri.widgets.Attachments.AttachmentsViewModel")], f);
var A = f;
export { A as default };